import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Countdown from "react-countdown";
import { renderAsHTML } from "../../utils";
import { injectIntl, intlShape } from "react-intl";
import messages from "../messagesDescription";

// eslint-disable-next-line react/prop-types
const renderer = (cb, intl) => ({ minutes, seconds, completed }) => {
  if (completed) {
    typeof cb == "function" && cb(true);
    return "";
  } else {
    const minsDisplay = minutes < 10 ? "0" + String(minutes) : String(minutes);
    const secsDisplay = seconds < 10 ? "0" + String(seconds) : String(seconds);
    return (
      <span style={{ fontSize: "0.875rem" }}>
        {renderAsHTML("div", intl.formatMessage(messages.expiryCodeCountdown, {
          minsDisplay: minsDisplay,
          secsDisplay: secsDisplay,
          time:
            minutes >= 1
              ? intl.formatMessage(messages.minsDescription)
              : intl.formatMessage(messages.secDescription),
        }))}
      </span>
    );
  }
};

const TwoFACountDown = ({ expireInSeconds, setOTPExpired, intl }) => {
  useEffect(() => {
    setOTPExpired(false);
  }, []);

  return (
    <Countdown
      date={Date.now() + expireInSeconds * 1000}
      renderer={renderer(() => setOTPExpired(true), intl)}
    />
  );
};

TwoFACountDown.propTypes = {
  expireInSeconds: PropTypes.number.isRequired,
  setOTPExpired: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

const MemoizedTwoFACountDown = React.memo(props => {
  return <TwoFACountDown {...props} />;
});
export default injectIntl(MemoizedTwoFACountDown);



// WEBPACK FOOTER //
// ./components/twoFA/TwoFACountDown.js